import { DateTime } from 'luxon';
import { hasStringValue } from './validation';
import { DATETIME_FORMAT_SERVER_UTC } from '@/constants/formats';

export function getCurrentTimeZone(): string {
  return DateTime.local().zoneName;
}

export function isoDatetimeToFormattedDatetime(isoDate: any, datetimeLocalFormat: string): any {
  if (!hasStringValue(isoDate)) {
    return isoDate;
  }
  return DateTime.fromISO(isoDate).toFormat(datetimeLocalFormat);
}

export function convertInputDateTimeToUtcDateTime(dateTime: Date): DateTime {
  return DateTime.fromJSDate(dateTime).toUTC();
}

export function convertInputDateToServerTime(dateTime: Date): string {
  return DateTime.fromJSDate(dateTime).toUTC().toFormat(DATETIME_FORMAT_SERVER_UTC);
}

export function convertInputDateToEndOfDayServerTime(dateTime: Date): string {
  return DateTime.fromJSDate(dateTime)
    .plus({ hours: 23 })
    .plus({ minutes: 59 })
    .plus({ seconds: 59 })
    .toUTC()
    .toFormat(DATETIME_FORMAT_SERVER_UTC)
    .replace('.000Z', '.999Z');
}
